import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Box,Select,MenuItem,FormControl,InputLabel
} from "@mui/material";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

import { useAuth } from "../../../AuthProvider";

const baseUrl=process.env.REACT_APP_API_BASE_URL
function RoleRegistrationList() {
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [userId, setUserId,] = useState("");
  console.log("user id"+userId)
  const {pricipalEmailId,oId,pId}=useAuth();
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [sendloading, setSendLoading] = useState(false); // State to control the loading indicator
  // const [selectedRow, setSelectedRow] = useState(null); // To store the row to edit
  // const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const navigate = useNavigate();
  const [patchloading, setPatchLoading] = useState(false); // State to manage loading indicator

  //changepassword
    const [showReceivedPassword, setShowReceivedPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  
      const fetchData = async () => {
        setLoading(true);
        try {
          const response = await fetch(`${baseUrl}/api/staffUserAdmission/getAll/${oId}/${pId}`);
          
          if (!response.ok) {
            // If server error (500, 404, etc), throw an error manually
            throw new Error(`HTTP error! status: ${response.status}`);
          }
      
          const data = await response.json();
          setFilteredData(Array.isArray(data) ? data : []); // Ensure it's always an array
        } catch (error) {
          console.error("Error fetching data: ", error);
          setFilteredData([]); // Show empty screen
        } finally {
          setLoading(false);
        }
      };
      
      useEffect(() => {
      fetchData();
    }, [oId]); // Re-fetch data when selected class or section changes

  const handleAddNew = () => {
    navigate("/PrincipalRoleRegistrations");
  };



const [dialogOpen, setDialogOpen] = useState(false);
// const [selectedRow, setSelectedRow] = useState(null);


const handleEditClick = (row) => {
  setSelectedRow(row); // Set the selected row
  setDialogOpen(true); // Open the dialog
};



const handleDialogClose = () => {
  setDialogOpen(false); // Close the dialog
  setSelectedRow(null); // Clear the selected row
};




const [users, setUsers] = useState([]);
const [selectedUserId, setSelectedUserId] = useState("");
const [selectedUserRole, setSelectedUserRole] = useState("");
const [selectedUserData, setSelectedUserData] = useState({
  firstName: "",
  lastName: "",
  contactNumber1: ""
});



useEffect(() => {
  if (selectedRow) {
    setSelectedUserData({
      firstName: selectedRow.firstName || "",
      lastName: selectedRow.lastName || "",
      contactNumber1: selectedRow.contactNumber || ""
    });
    setSelectedUserId(selectedRow.employeeId || "");
    setSelectedUserRole(selectedRow.userRoleName || "");
  }
}, [selectedRow]);


const handleChange = (e) => {
  const { name, value } = e.target;
  setSelectedUserData((prevData) => ({
    ...prevData,
    [name]: value,
  }));
};



const handleSaveChanges = async () => {
  if (!selectedRow) return;

  if (!selectedUserData?.firstName) {
    toast.error("First Name is required!", { autoClose: 2000 });
    return;
  }
  if (!selectedUserData?.lastName) {
    toast.error("Last Name is required!", { autoClose: 2000 });
    return;
  }
  // if (!selectedUserData?.contactNumber1) {
  //   toast.error("Contact Number is required!", { autoClose: 2000 });
  //   return;
  // }

  const queryParams = new URLSearchParams({
    firstName: selectedUserData.firstName,
    lastName: selectedUserData.lastName,
    contactNumber: selectedUserData.contactNumber1, // API expects this key
  }).toString();

  setPatchLoading(true);

  try {
    const response = await fetch(
      `${baseUrl}/api/principal/updateUserStaffRoleDetails/${selectedRow.id}?${queryParams}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to update the user");
    }

    toast.success("User updated successfully!", { autoClose: 1000 });
    fetchData(); // Refresh list
    handleDialogClose(); // Close dialog
  } catch (error) {
    console.error("Error updating user:", error);
    toast.error("Error updating user. Please try again.", { autoClose: 2000 });
  } finally {
    setPatchLoading(false);
  }
};











  const handleSendValue = async () => {
    if (!selectedRow?.userIds) {
      toast.error("User ID is required!", { autoClose: 2000 });
      return;
    }
    setSendLoading(true); // Start the loading indicator
    try {
      const response = await fetch(`${baseUrl}/api/users/forgot-password/${selectedRow.userIds}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      let data;
      if (response.ok) {
        
        data = await response.text();
        console.log("Response:", data); // Check if it's plain text "ADM-001"
        setUserId(data); // Update state with the response value
        toast.success("Password Sent To Email Successfully!", { autoClose: 1000 });
      } else {
        const errorMessage = data?.message || "Failed to send data";
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error("Error sending Password:", error);
      toast.error(error.message || "Failed to send Password.", { autoClose: 2000 });
    }finally {
      setSendLoading(false); // Stop the loading indicator after the request is done
    }
  };
  
  
  
  

  const handleChangePasswordOpen = (row) => {
    setSelectedRow(row);
    setChangePasswordOpen(true);
    // setUserId(row?.userIds || "");
  };

  const handleChangePasswordClose = () => {
    setChangePasswordOpen(false);
    // setUserId("");
    setOtp("");
    setNewPassword("");
    setConfirmPassword("");
    setSelectedRow(null);
  };



  const handleSavePassword = async () => {
    console.log("Debugging:", { userId, otp, newPassword, confirmPassword });
  
    if (!userId || !otp || !newPassword || !confirmPassword) {
      toast.error("All fields are required!", { autoClose: 2000 });
      return;
    }
  
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match!", { autoClose: 2000 });
      return;
    }
  
    try {
      const response = await fetch(
        `${baseUrl}/api/users/change-password?input=${userId}&oldPassword=${otp}&newPassword=${newPassword}&confirmPassword=${confirmPassword}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      let data;
      const contentType = response.headers.get("content-type");
  
      if (contentType && contentType.includes("application/json")) {
        data = await response.json();
      } else {
        data = await response.text();
      }
  
      if (response.ok) {
        
        toast.success(data || "Password changed successfully!", { autoClose: 1000 });
        handleChangePasswordClose();
      } else {
        throw new Error(data?.message || data || "Failed to change password");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      toast.error(error.message || "Failed to change password.", { autoClose: 2000 });
    }
  };

  const filteredResults = filteredData.filter((row) => {
    if (!searchQuery) return true; // Show all if no search input
  
    const firstName = row.firstName?.toLowerCase() || "";
    const lastName = row.lastName?.toLowerCase() || "";
    const contactNumber = row.contactNumber?.toLowerCase() || "";
    const query = searchQuery.toLowerCase();
  
    return firstName.includes(query) || lastName.includes(query) || contactNumber.includes(query);
  });
  
  
  

  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        // height: "1000px",
        // overflow: "hidden",
      }}
    >
      <CardContent
        // style={{
        //   width: "950px",
        //   margin: "auto",
        // }}
      >
        {/* Title Section */}
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography
              variant="h4"
              style={{ fontWeight: "bold", color: "#333" }}
            >
              Registered Roles
            </Typography>
          </Grid>
        </Grid>

        {/* Search and Add New Button Section */}
        <Grid
  container
  spacing={2}
  alignItems="center"
  justifyContent="space-between"
  style={{ marginTop: "1px" }}
>
 
  <Grid item xs={3}>
  <TextField
    fullWidth
    label="Search by Name or Contact"
    variant="outlined"
    size="small"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
  />
</Grid>



  <Grid item xs="auto">
    <Button
      variant="contained"
      onClick={handleAddNew}
      sx={{
        backgroundColor: "#3C3972",
        color: "white",
       fontWeight:'bold',
        "&:hover": {
            backgroundColor: "#3C3972",
        },
        }}
    >
      Register New Roles
    </Button>
  </Grid>
</Grid>


<GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />
        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "400px",
            overflowY: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontSize:'14px',fontWeight:'bold'}}>S.No</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontSize:'14px',fontWeight:'bold'}}>Name</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontSize:'14px',fontWeight:'bold'}}>Phone No</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontSize:'14px',fontWeight:'bold'}}>Role</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontSize:'14px',fontWeight:'bold'}}>UserId</TableCell>
         
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontSize:'14px',fontWeight:'bold'}}>Password</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontSize:'14px',fontWeight:'bold'}}>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center", padding: "20px" }}>
                                         <Box display="flex" flexDirection="column" alignItems="center">
                                           <CircularProgress />
                                           <Typography variant="body2" sx={{ mt: 1 }}>
                                             Loading Data...
                                           </Typography>
                                         </Box>
                                       </TableCell>
                </TableRow>
              ) : filteredResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredResults.map((row, index) => (
                  <TableRow key={row.id} style={{
                    backgroundColor: "white",
                    transition: "background-color 0.3s",
                    height: "40px",  // Reduced row height
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "white"; // Default color
                  }}>
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{index + 1}</TableCell>

                  
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.firstName} {row.lastName}</TableCell>
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.contactNumber || "N/A"}</TableCell>
               
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.userRoleName}</TableCell>
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.userIds}</TableCell>
              
                    <TableCell sx={{ textAlign: "center",borderRight: "1px solid #ddd", padding: "2px" }}>

                    
                       <Button
                                      type="button"
                                      onClick={() => handleChangePasswordOpen(row)} // Open dialog with the row data
                                      sx={{
                                        backgroundColor: "#1976d2",
                                        color: "white",
                                        fontSize: "0.6rem", // Reduces the font size
                                        height: "25px", // Reduces the height
                                        fontWeight:'bold',                                        "&:hover": {
                                          backgroundColor: "#1565c0",
                                        },
                                      }}
                                    >
                                      Change Password
                                    </Button>

                    </TableCell>

                    <TableCell sx={{ textAlign: "center",borderRight: "1px solid #ddd", padding: "2px" }}>


                        <Button
                            type="button"
                            onClick={() => handleEditClick(row)} // Open dialog with the row data
                            sx={{
                            backgroundColor: "#1976d2",
                            color: "white",
                            fontSize: "0.6rem", // Reduces the font size
                            height: "25px", // Reduces the height
                            fontWeight:'bold',    
                            "&:hover": {
                                backgroundColor: "#1565c0",
                            },
                            }}
                        >
                            EDIT
                        </Button>

                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>


          {/* Dialog for change password */}
          <Dialog open={changePasswordOpen} onClose={handleChangePasswordClose} maxWidth="xs" fullWidth>
        <DialogTitle variant="h4" sx={{fontWeight:'bold'}}>Change Password</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{marginTop:'0px'}} >
            <Grid item xs={8}>
              <TextField
                label="User ID"
                value={selectedRow?.userIds || ""} 
                onChange={(e) => setUserId(e.target.value)}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
    <Button
      variant="contained"
      color="secondary"
      fullWidth
      sx={{
        width: "50%",
        backgroundColor: "#3C3972",
        color: "white",
        "&:hover": { backgroundColor: "#3C3972" },
      }}
     
      onClick={handleSendValue} // Calls the function when clicked
      disabled={sendloading} // Disable the button when loading
    >
      {sendloading ? (
        <CircularProgress size={24} sx={{ color: 'white' }} /> // Show loading spinner
      ) : (
        "Send" // Button text when not loading
      )}
    </Button>
  </Grid>
            <Grid item xs={12}>
              <TextField
                label="Enter Received Password"
                type={showReceivedPassword ? 'text' : 'password'}
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                fullWidth
                size="small"
                 InputProps={{
                  endAdornment: (
                    <IconButton onClick={() => setShowReceivedPassword(!showReceivedPassword)}>
                      {showReceivedPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  )
                            }}
              />

              
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Enter New Password"
                type={showNewPassword ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                fullWidth
                size="small"
                InputProps={{
                  endAdornment: (
                    <IconButton onClick={() => setShowNewPassword(!showNewPassword)}>
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  )
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label=" Enter Confirm Password"
                type={showConfirmPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                fullWidth
                size="small"
                 InputProps={{
                                        endAdornment: (
                                          <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                          </IconButton>
                                        )
                                      }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleChangePasswordClose} color="primary" variant="outlined">Cancel</Button>
          
          <Button
            onClick={handleSavePassword}
           
            color="primary"
            sx={{ backgroundColor: "#3C3972", color: "white", "&:hover": { backgroundColor: "#3C3972" } }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer position="top-right" autoClose={1000} />




        {/* Dialog for editing */}
        <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="sm" fullWidth>
  <DialogTitle sx={{fontWeight:'bold',fontSize:'15px'}}>Edit Registered Roles</DialogTitle> 
  <DialogContent>
    <Grid container spacing={2} sx={{marginTop:'0px'}}>
      
      

<Grid item xs={6}>
            <FormControl fullWidth sx={{ marginTop: '15px' }} disabled>
              <InputLabel>Select Role</InputLabel>
              <Select
                name="userRoleName"
                value={selectedRow?.userRoleName || ""}
                onChange={(e) => setSelectedUserRole(e.target.value)}
                label="Select Role"
                disabled // important: disable the Select itself
                sx={{
                  backgroundColor: "#f0f0f0",
                  color: "#6c757d",
                  fontWeight: "bold",
                  ".MuiSelect-select": {
                    padding: "12px", // optional padding tweak
                  }
                }}
              >
                <MenuItem value="ADMISSION_FEE">ADMISSION_FEE</MenuItem>
                <MenuItem value="EXAMINATION_CELL">EXAMINATION_CELL</MenuItem>
                <MenuItem value="SCHEDULE_MEETING">SCHEDULE_MEETING</MenuItem>
                <MenuItem value="TRANSPORT">TRANSPORT</MenuItem>
                <MenuItem value="HRBP">HUMAN RESOURCE</MenuItem>
              </Select>
            </FormControl>


      </Grid>
      <Grid item xs={6} sx={{marginTop:'15px'}}>
        <TextField 
          label="User ID" 
          name="userId" 
          value={selectedRow?.userIds || ""} 
          fullWidth 
         
          size="small"
          disabled
          InputProps={{
            style: {
              backgroundColor: "#f0f0f0",
              color: "#6c757d",
              fontWeight: "bold",
              height:'45px'
            },
          }}
        />
      </Grid>
      <Grid item xs={6}>
  <TextField
    label="First Name"
    name="firstName"
    fullWidth
    value={selectedUserData.firstName}
    onChange={handleChange} // ✅
  />
</Grid>

<Grid item xs={6}>
  <TextField
    label="Last Name"
    name="lastName"
    fullWidth
    value={selectedUserData.lastName}
    onChange={handleChange} // ✅
  />
</Grid>

<Grid item xs={6}>
  <TextField
    label="Contact Number"
    name="contactNumber1"
    fullWidth
    value={selectedUserData.contactNumber1}
    onChange={handleChange} // ✅
  />
</Grid>


      
    </Grid>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleDialogClose} color="primary" variant="outlined">Cancel</Button>
    <Button 
  onClick={handleSaveChanges} 
  color="primary" 
  disabled={patchloading} // Disable button while loading
  sx={{ backgroundColor: "#3C3972", color: "white", "&:hover": { backgroundColor: "#3C3972" } }}
>
  {patchloading ? <CircularProgress size={24} color="inherit" /> : "Save"}
</Button>

  </DialogActions>
</Dialog>







      </CardContent>
    </Card>
  );
}

export default RoleRegistrationList;